import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface BoletinModalConfig {
  nombre: string;
  descripcion: string;
  activo: boolean;
  fechaVigencia: string;
  archivoPath: string;
  tipo: 'PDF' | 'IMAGE';
}

@Component({
  selector: 'app-modal-boletines-dinamico',
  templateUrl: './modal-boletines-dinamico.component.html',
  styleUrls: ['./modal-boletines-dinamico.component.css']
})
export class ModalBoletinesDinamicoComponent implements OnInit {
  public oculto = 'oculto';
  public boletinesActivos: BoletinModalConfig[] = [];
  public indiceActual = 0;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.cargarBoletines();
  }

  get boletinActual(): BoletinModalConfig {
    return this.boletinesActivos[this.indiceActual];
  }

  get hayMasBoletines(): boolean {
    return this.boletinesActivos.length > 1;
  }

  get esPdfActual(): boolean {
    if (!this.boletinActual) {
      return false;
    }
    return this.boletinActual.tipo === 'PDF';
  }

  get archivoActualSanitizado(): SafeResourceUrl {
    let ruta = this.obtenerRutaArchivo(this.boletinActual.archivoPath);
    if (this.esPdfActual && ruta) {
      ruta += '#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0';
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(ruta);
  }

  get archivoActual(): string {
    return this.obtenerRutaArchivo(this.boletinActual.archivoPath);
  }

  cerrarBoletin() {
    if (this.hayMasBoletines) {
      this.boletinesActivos.splice(this.indiceActual, 1);
      if (this.indiceActual >= this.boletinesActivos.length) {
        this.indiceActual = 0;
      }
      return;
    }
    this.oculto = 'oculto';
  }

  private cargarBoletines() {
    this.http.get<BoletinModalConfig[]>('assets/data/boletines-modal.json')
      .subscribe((boletines) => {
        this.boletinesActivos = (boletines || []).filter((boletin) => this.boletinEsVisible(boletin));
        if (this.boletinesActivos.length > 0) {
          this.oculto = '';
        }
      }, () => {
        this.oculto = 'oculto';
      });
  }

  private boletinEsVisible(boletin: BoletinModalConfig): boolean {
    if (!boletin || !boletin.activo) {
      return false;
    }

    const vigencia = this.parsearFechaVigencia(boletin.fechaVigencia);
    if (!vigencia) {
      return false;
    }

    const ahora = new Date();
    return ahora.getTime() <= vigencia.getTime();
  }

  private parsearFechaVigencia(fecha: string): Date {
    if (!fecha) {
      return null;
    }

    const partes = fecha.split('-');
    if (partes.length !== 3) {
      return null;
    }

    const anio = Number(partes[0]);
    const mes = Number(partes[1]) - 1;
    const dia = Number(partes[2]);

    const fechaVigencia = new Date(anio, mes, dia, 23, 59, 59, 999);
    if (fechaVigencia.getFullYear() !== anio || fechaVigencia.getMonth() !== mes || fechaVigencia.getDate() !== dia) {
      return null;
    }

    return fechaVigencia;
  }

  private obtenerRutaArchivo(pathArchivo: string): string {
    if (!pathArchivo) {
      return '';
    }

    if (pathArchivo.indexOf('http://') === 0 || pathArchivo.indexOf('https://') === 0 || pathArchivo.indexOf('assets/') === 0) {
      return encodeURI(pathArchivo);
    }

    return encodeURI('assets/' + pathArchivo);
  }
}
